$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});
});

window.graph = (function () {
    var bPercent, wPercent;
    var bTXT, wTXT;

    style = function (b, w) {
        bPercent = b;
        wPercent = w;
        if(wPercent === 0){
            $('.graph').addClass('default');
        } else {
            $('.graph').removeClass('default');
        }
        $('.graph-blue').css({'width': bPercent + '%'})
    };
    txt = function (b, w) {
        bTXT = b;
        wTXT = w;
        $('.graph-blue-txt').text(bTXT + "(" + bPercent + "%)");
        $('.graph-white-txt').text(wTXT + "(" + wPercent + "%)");
    };
    return {
        setStyle: style,
        setTXT: txt
    }
})();


// WEBPACK FOOTER //
// ./src/js/index.js